import http from 'conversations-http/clients/http';
export const markPromptAsShown = ({
  promptType
}) => http.put(`cv/inbox/settings/v1/user-prompts/viewed`, {
  query: {
    promptType
  }
});